;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.communityReroute = (function () {
    const initialize = function () {
      // console.log("Init Community Reroute");
      if ($('.masthead.communities').length) {
        // Iterate through each link's href, and if you find the phrases 'lylebrooke' or 'harlow', change the href.
        $('a.community-link-hook').each(function () {
          const myHREF = $(this).attr('href')
          // console.log("Checking href " + myHREF);
          if (/harlow/i.test(myHREF)) {
            $(this).attr('href', '/harlow')
            // console.log("modified a harlow");
          }
          /* if (/edenton/i.test(myHREF)) {
            $(this).attr('href','/edenton');
            //console.log("modified a harlow");
          }
          if (/havenridge/i.test(myHREF)) {
            $(this).attr('href','/havenridge');
            //console.log("modified a harlow");
          } */
          /*
          // Lylebrooke is live, so this page no longer accessible. Z Gaskins 3/18/2016
            if (/lylebrooke/i.test(myHREF)) {
              $(this).attr('href','/lylebrooke');
              //console.log("modified a lylebrooke");
          }
          */
        })
      }
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.communityReroute.initialize()
  })
}(jQuery, window))
